import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-action',
  templateUrl: './custom-action.component.html',
  styleUrls: ['./custom-action.component.css']
})
export class CustomActionComponent implements OnInit {
  @Input() rowData: any; // Données de la ligne actuelle
  @Output() charge = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

   isInactive: boolean = false;

  ngOnInit() {
    // Vérifier si l'employé est inactif (statut PENDING)
    this.isInactive = this.rowData?.mustChangePassword === true;
  }

  onChargeClick() {
   // console.log("Ajouter pour:", this.rowData);
    this.charge.emit(this.rowData);
  }

  onDeleteClick() {
    //console.log("Supprimer :", this.rowData);
    this.delete.emit(this.rowData);
  }
}
